export default "__VITE_PUBLIC_ASSET__59fef00e__"